export default "\n<ngx-skeleton-loader [count]=\"count\" \n[appearance]=\"appearance\" \n[theme]=\"theme\">\n</ngx-skeleton-loader>"